import { AnnualStatementEmailPayload } from "./annual-statement-email-payload";

export class AnnualStatementEsignEmailPayload extends AnnualStatementEmailPayload {
  static override $type = 'AnnualStatementEsignEmailPayload';

  signUrl: string;

  constructor(data: Partial<AnnualStatementEsignEmailPayload> = {}) {
    super(data);
    this.signUrl = data.signUrl ?? '';
  }

}
